/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/01/2025
*/


import * as React from 'react';
import { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Styles from './weCanHelp.module.css';
import { Grid } from '@mui/material';
import { blue } from '@mui/material/colors';
import Divider from '@mui/material/Divider';

export default function WeCanHelp() {

    const [mapIndex , setMapIndex] = useState(8);

    const handleShowAll = () =>{
        if(mapIndex===8){
            setMapIndex(15)
        }else{
            setMapIndex(8);
        }
    }

    const questions = [
        { id: '1', question: 'What services N-ACH offers?', answer: 'We provide standalone products, custom software development, web and mobile app development, cloud solutions, UI/UX design, and IT consulting.' },
        { id: '2', question: 'Do you specialize in any particular industry?', answer: 'We work across multiple industries, including e-commerce, fintech, healthcare, education, and logistics.' },
        { id: '3', question: 'What technologies do you use?', answer: 'We work with modern technologies like JavaScript (React, Next Js), Python, Java, .NET, PHP, Node.js, and cloud platforms like AWS, Azure, and Digital Ocean.' },
        { id: '4', question: 'How do you ensure software quality?', answer: 'We follow best practices, including automated testing, code reviews, and Agile methodologies to maintain high-quality standards.' },
        { id: '5', question: 'Do you offer maintenance and support after development?', answer: 'Yes, we provide ongoing support, bug fixes, updates, and enhancements after deployment.' },
        { id: '6', question: 'How long does a project take?', answer: 'The timeline depends on the project\'s complexity and requirements, typically ranging from a one Month to several months.' },
        { id: '7', question: 'What is your development process?', answer: 'We follow Agile and Scrum methodologies, ensuring flexibility, transparency, and continuous client involvement.' },
        { id: '8', question: 'Can you work with an existing project or legacy system?', answer: 'Yes, we can improve, migrate, or maintain existing software solutions.' },
        { id: '9', question: 'How do you handle project communication?', answer: 'We use collaboration tools like Jira, Clickups, Azure Deveops and regular meetings via Teams, WhatsApp or Google Meet.' },
        { id: '10', question: 'What if I need changes during development?', answer: 'We accommodate changes through Agile development, allowing adjustments based on feedback.' },
        { id: '11', question: 'How much does software development cost?', answer: 'Our costs are reasonable and transparent. The cost varies based on complexity, features, and timeline. We provide customized quotes after assessing your needs.' },
        { id: '12', question: 'Do you offer fixed-price or monthly contracts?', answer: 'We offer both fixed-price and monthly contracts based on project scope.' },
        { id: '13', question: 'Do you provide free consultations?', answer: 'Yes, we offer free initial consultations to understand your requirements.' },
        { id: '14', question: 'What is Zero-Distance Ideas?', answer: 'We continuously provide new business ideas to our clients to improve their business and complete with their rivals.' },
        { id: '15', question: 'What payment methods do you accept?', answer: 'We accept bank transfers, credit cards (depending on your location).' },
    ]


    return (
        <div>
            <div className={Styles.outerContainer}>
                {/* <Typography className={Styles.description} >Need for Achievement</Typography> */}
                <Typography className={Styles.topic}>Frequently Asked Questions</Typography>
                <Grid container spacing={3} justifyContent="left">
                    {questions.slice(0, mapIndex).map((question , index) => (
                        <Grid item xs={12} sm={6} md={6} key={question.id}>
                            <Accordion key={question.id} sx={{ minHeight: 70, border: 'none', boxShadow: 'none' }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ color: blue[500] }} />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Typography component="span" variant="h6" sx={{ fontWeight: 600 }} className={Styles.accordionQuestion}>{question.question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ fontFamily: 'Livvic' }} variant="body1">
                                    <Divider sx={{marginBottom:2}} />
                                    {question.answer}</AccordionDetails>
                            </Accordion>
                        </Grid>
                    ))}
                </Grid>
                    <Button variant="text" sx={{ m:10}} onClick={handleShowAll}>{mapIndex===8 ?  "See all questions..." : "Show less..."}</Button>
            </div>
        </div>
    );
}
